import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { colors, fontSize } from "style";
import { Row } from "components/Containers";
import Overlay from "components/Overlay";
import { PopoverCard } from "components/ActivityLog";
import ListTable from "components/ListTable";

/**
 * ApplicantViewsCount
 *
 * @param {Object} viewsCount
 */
const ApplicantViewsCount = ({ viewsCount }) => {
  if (!viewsCount) return null;

  return (
    <Row noWrap>
      {viewsCount?.totalViews > 0 ? (
        <Overlay
          overlay={
            <PopoverCard>
              <ListTable data={TABLE_DATA(viewsCount)} />
            </PopoverCard>
          }
          trigger={
            <Row gap="0.4rem" noWrap>
              <FormattedMessage
                id="Missions.Applicants.ApplicantViewsCount"
                values={{
                  count: <div css={styles.icon_container}>{viewsCount?.totalViewsWithoutAdmin || 0}</div>,
                }}
              />
            </Row>
          }
        />
      ) : (
        <Row gap="0.4rem" noWrap>
          <FormattedMessage
            id="Missions.Applicants.ApplicantViewsCount"
            values={{
              count: <div css={styles.icon_container}>{viewsCount?.totalViewsWithoutAdmin || 0}</div>,
            }}
          />
        </Row>
      )}
    </Row>
  );
};

const TABLE_DATA = (data) => [
  {
    label: <FormattedMessage id="Missions.Applicants.ApplicantViewsCount.TotalViews" />,
  },
  ...Object.entries(data?.totalViewsBreakdown || {})
    .filter(([role]) => role !== "__typename")
    .map(([role, count]) => ({
      label: <span css={styles.normal_text}>{ROLE_MAPPING[role] || role}</span>,
      value: count,
    })),
];

const ROLE_MAPPING = {
  admin: "Admin (not included in total)",
  client: "Client",
  freelancer: "Member",
  system: "Public",
};

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight3};
    font-size: ${fontSize.xxsmall};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  normal_text: css`
    font-weight: normal;
  `,
};

ApplicantViewsCount.propTypes = {
  viewsCount: PropTypes.object.isRequired,
};

export default ApplicantViewsCount;
